export default __webpack_public_path__ + "static/media/VideoThumbImg.89963877.png";